import { ModalHeader } from "../components/common/modalHeader";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { WinningType } from "../models/enum/winningType";
import { CheckedInSearchForm } from "../components/checkedInList/checkedInSearchForm";
import { useFanInfo } from "../hooks/useFanInfo";
import { useParams } from "react-router-dom";
import { QueryResult } from "../components/checkedInList/queryResult";

export function CheckedInUser() {
  const { artistId, eventId, rewardId } = useParams();
  const artistIdNum = Number(artistId) ?? 0;
  const eventIdNum = Number(eventId) ?? 0;
  const rewardIdNum = Number(rewardId) ?? 0;
  const { t } = useTranslation();
  const [winnerType, setWinnerType] = useState<WinningType>(
    WinningType.REGULAR,
  );
  const [searchValue, setSearchValue] = useState<string | null>(null);
  const [search, setSearch] = useState(false);
  const { fanInfo, refetch, isLoading } = useFanInfo(
    artistIdNum,
    eventIdNum,
    rewardIdNum,
    { winnerType, searchValue },
    false,
  );

  useEffect(() => {
    const fetch = async () => {
      await refetch();
      setSearch(false);
    };

    if (search) {
      fetch().then();
    }
    //eslint-disable-next-line
  }, [search]);

  return (
    <div className={"flex flex-col h-full"}>
      <ModalHeader title={t("checkinlist_subtitle")}></ModalHeader>
      <CheckedInSearchForm
        onSearch={(type, value) => {
          setWinnerType(type);
          setSearchValue(value);
          setSearch(true);
        }}
        loading={isLoading}
      />
      {fanInfo !== undefined && (
        <QueryResult
          artistId={artistIdNum}
          eventId={eventIdNum}
          rewardId={rewardIdNum}
          fanInfo={fanInfo}
          onChangeStatus={() => {
            refetch().then();
          }}
        />
      )}
    </div>
  );
}
